<template>


    <v-dialog v-model="shownRelay" :overlay-opacity="0.8" width="85%" overlay-color="black">
        <v-card class="d-flex flex-column" style="max-height: 90vh">
            <div class="d-flex align-center">
                <div class="dlg-title-bar flex-grow-1">
                    Screenshots
                </div>

                <div class="py-2">
                    <v-text-field
                            v-model="searchStr"
                            clearable
                            outlined
                            dense
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            placeholder="Search"
                    ></v-text-field>
                </div>

                <div class="px-2">
                    <v-btn
                            icon
                            color="error"
                            @click="shownRelay = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <div class="flex-grow-1 of-y" @scroll="scrollEvent" ref="scrollDiv">

                <div class="d-flex flex-column justify-center" v-for="day in screensByDateTime.values()" :key="day.dy">
                    <div class="d-flex align-center">
                        <div class="circle-small-outline">
                            <v-icon color="primary">mdi-calendar</v-icon>
                        </div>
                        <div class="date-title">
                            {{ format(day.date, dateFormats.longDateOnly) }}
                        </div>
                    </div>

                    <div class="line"></div>

                    <div class="d-flex align-stretch" v-for="hour in day.hourMap.values()">

                        <div class="d-flex flex-column">
                            <div class="d-flex align-center">
                                <div class="time-title">
                                    {{ format(hour.date, dateFormats.hourOnly) }}
                                </div>
                                <div class="circle-small"></div>
                            </div>
                            <div class="line flex-grow-1"></div>
                        </div>

                        <div class="pa-2 pl-10 d-flex align-stretch flex-wrap">
                            <div v-for="shot in hour.shots" class="flex-grow-1 pb-8 pr-8" style="max-width: 350px" :key="shot._id">
                                <app-screenshot-card
                                        :screenshot="shot"
                                        @showScreenshot="$emit('showScreenshot', shot)"
                                        @gotoDeviceSettings="$emit('gotoDeviceSettings', $event)"
                                        @gotoEmployee="$emit('gotoEmployee', $event)"
                                        @gotoTeam="$emit('gotoTeam', $event)"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="d-flex flex-column">
                        <div class="d-flex align-center">
                            <div class="time-title">
                                <template v-if="drawLimit < filteredScreenShots.length">
                                    +{{filteredScreenShots.length - drawLimit}}
                                </template>
                            </div>
                            <div class="circle-small"></div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-center pa-5" v-if="drawLimit < filteredScreenShots.length">
                    <v-btn
                            outlined
                            color="primary"
                            @click="drawLimit = drawLimit + 50 >= filteredScreenShots.length ? filteredScreenShots.length : drawLimit + 50"
                            :loading="true"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        Load More
                    </v-btn>
                </div>
            </div>
        </v-card>
    </v-dialog>


</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppScreenshotCard from "@/components/Shared/Screenshots/AppScreenshotCard";
import {dateFormats} from "@/core/codeFunctions";
import {format} from "date-fns";

export default {
    components: {AppScreenshotCard},
    props: {
        filter: Object,
        screenshots: Array,
        shown: Boolean,
        initialFilter: String
    },
    data() {
        return {
            showDlg: false,
            format,
            dateFormats,
            searchStr: null,
            drawLimit: 20
        }
    },

    mounted() {
        this.drawLimit = 20
        this.searchStr = this.initialFilter
    },

    methods: {

        scrollEvent(ev) {

            if (this.drawLimit < this.filteredScreenShots.length) {
                const scrollDiv = this.$refs.scrollDiv
                const total = this.$refs.scrollDiv.scrollHeight
                const scrollBottom = scrollDiv.scrollTop + scrollDiv.clientHeight

                const percentage = (scrollBottom / total) * 100
                const itemsVisible = (this.drawLimit / 100) * percentage
                const itemsToGo = Math.floor(this.drawLimit - itemsVisible)

                if (itemsToGo <= 10 || percentage > 99) {
                    this.drawLimit = this.drawLimit + 10 >= this.filteredScreenShots.length ? this.filteredScreenShots.length : this.drawLimit + 10
                }
            }
        },
    },
    computed: {
        ...mapGetters(['devicesWithAccess']),
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit('update:shown', val)
            }
        },
        numberOfPages() {
            return Math.ceil(this.filteredScreenShots.length / this.itemsPerPage)
        },

        filteredScreenShots() {
            return this.screenshots.filter(shot => {
                if (!this.searchStr)
                    return true
                else
                    return (shot.match + shot.deviceName + shot.employeeName + shot.teamName + shot.dyhms).toLowerCase().includes((this.searchStr.toLowerCase() || ''))
            })
        },

        screensByDateTime() {
            const shots = this.filteredScreenShots.map(obj => {
                obj.dy = format(obj.start, 'yyyy-MM-dd');
                obj.dyh = format(obj.start, 'yyyy-MM-dd HH:00:00')
                obj.dyhms = format(obj.start, 'yyyy-MM-dd HH:mm:ss')
                return obj
            })
                    .sort((a, b) => a.start > b.start ? -1 : 1)

            shots.splice(this.drawLimit, shots.length - this.drawLimit)

            const days = shots.reduce((dayMap, shot) => {
                const day = dayMap.has(shot.dy)
                        ? dayMap.get(shot.dy)
                        : dayMap.set(shot.dy, {
                            day: shot.dy,
                            date: new Date(shot.dy),
                            hourMap: new Map()
                        }).get(shot.dy);
                const hour = day.hourMap.has(shot.dyh)
                        ? day.hourMap.get(shot.dyh)
                        : day.hourMap.set(shot.dyh, {
                            hour: shot.dyh,
                            date: new Date(shot.dyh),
                            shots: []
                        }).get(shot.dyh);
                hour.shots.push(shot)
                return dayMap
            }, new Map())

            return days
        }

    }

}
</script>

<style scoped>

* {
    box-sizing: border-box;
}


.date-title {
    padding-left: 12px !important;
    font-weight: 300 !important;
    font-size: 1.5rem !important;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
}

.time-title {
    color: var(--v-primary-base);
    padding-right: 4px !important;
    font-size: 0.75rem !important;
    letter-spacing: 0.0333333333em !important;
    line-height: 1.25rem;
    font-family: "Roboto", sans-serif !important;
    font-weight: 700 !important;
    text-align: end !important;
    width: 50px;
}

.circle-small {
    background: var(--v-primary-base);
    border-radius: 9px;
    width: 18px;
    height: 18px;
    align-items: center !important;
    justify-content: center !important;
    display: flex !important;
    border: none;
}

.line {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 58px;
    background: var(--v-primary-base);
    width: 2px;
    min-height: 10px;
}

.circle-small-outline {
    margin-left: 37px;
    /*margin-left: 152px;*/
    border: 2px solid var(--v-primary-base);
    color: var(--v-primary-base);
    border-radius: 22px;
    width: 44px;
    height: 44px;
    align-items: center !important;
    justify-content: center !important;
    display: flex !important;
    margin-top: 1px;
    margin-bottom: 1px;
}
</style>